"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _default = {
  "vetto": {
    "ba7ddbcb": [{
      "hkey": "3eb55b21",
      "slug": "cola-predella",
      "name": "Cola-Predella",
      "primary": true,
      "skipSearch": false
    }],
    "cola": [{
      "hkey": "3eb55b21",
      "slug": "cola-predella",
      "name": "Cola-Predella",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": null
    }],
    "4fa6e720": [{
      "hkey": "de151bf5",
      "slug": "vetto",
      "name": "Vetto",
      "primary": true,
      "skipSearch": false
    }],
    "crovara": [{
      "hkey": "de151bf5",
      "slug": "vetto",
      "name": "Vetto",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "ba4c201f": [{
      "hkey": "de151bf5",
      "slug": "vetto",
      "name": "Vetto",
      "primary": true,
      "skipSearch": false
    }],
    "santo-stefano": [{
      "hkey": "de151bf5",
      "slug": "vetto",
      "name": "Vetto",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }]
  }
};
exports["default"] = _default;